import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BigNumbers from '../dashboard/bigNumbers/bigNumbers';
import { DataSource } from '../dashboard/bigNumbers/types';
import { ChartsPage } from '../dashboard/charts';
import { generateOffersPrimaryCharts } from '../dashboard/realtyOffersPrimary/redux/offersPrimary.controller';
import { generatePrimaryMarketGeneralCharts } from '../dashboard/realtyOffersPrimaryGeneral/redux/offersPrimary.controller';
import { generateChartsOffersSecondary } from '../dashboard/realtyOffersSecondary/redux/offersSecondary.controller';
import { generateCharts } from '../dashboard/realtyTransactions/redux/realtyTransactions.controller';
import { getSocioeconomicChartsData } from '../dashboard/socioeconomicDemographic/redux/socioeconomicDemographic.controller';

import { AddAlert } from '../../component';
import { generateSecondaryMarketGeneralCharts } from '../dashboard/realtyOffersSecondaryGeneral/redux/offersSecondary.controller';

function ReportResults() {
  const dispatch = useDispatch();
  const { preference } = useSelector((state: any) => state.layoutState);
  const { displayCharts } = useSelector((state: any) => state.dashboardState);
  const { bigNumbers } = useSelector((state: any) => state.bigNumbersState);
  const { displayBigNumbersSocioeconomicDemographic, geocodePayload } =
    useSelector((state: any) => state.socioeconomicDemographicState);
  const { payloadRequest } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  const { payloadChartsTransactions } = useSelector(
    (state: any) => state.realtyTransactionsState
  );

  const { primaryChartData } = useSelector(
    (state: any) => state.offersPrimaryGeneralState
  );

  const { secondaryChartData } = useSelector(
    (state: any) => state.offersSecondaryGeneralState
  );

  // const { transactionsChartData } = useSelector(
  //   (state: any) => state.realtyTransactionsGeneralState
  // );

  const [showBigNumbers, setShowBigNumbers] = useState(false);
  const [showChart, setShowChart] = useState(false);

  const nls = require(`../dashboard/nls/${preference.language.id}.json`);

  const dataSourceSocioeconomic: DataSource = {
    display: true,
    data: {
      average_dwellers_per_household: nls.dataSource.dataSourceIBGE2010,
      demografic_density: nls.dataSource.dataSourceIBGE2010,
      dwellers_count: nls.dataSource.dataSourceIBGE2010,
      household_count: nls.dataSource.dataSourceIBGE2010,
      verticalization_index: nls.dataSource.dataSourceIPTU2020,
    },
  };

  const GENERAL_MARKETS: Record<string, string> = {
    primary: 'primaryMarketGeneral',
    secondary: 'secondaryMarketGeneral',
    transactions: 'transactionsGeneral',
  };

  const GENERAL_MARKETS_KEYS = Object.values(GENERAL_MARKETS);

  const generatingFunctionForEachRealty = () => {
    if (GENERAL_MARKETS_KEYS.includes(displayCharts)) {
      verifyGeneralMarketsChartData(displayCharts);
    } else {
      const realtyFunction: Record<string, () => void> = {
        primaryMarket: () => dispatch(generateOffersPrimaryCharts()),
        secondaryMarket: () =>
          dispatch(generateChartsOffersSecondary(payloadRequest)),
        transactions: () => dispatch(generateCharts(payloadChartsTransactions)),
        socioeconomicDemographic: () =>
          dispatch([getSocioeconomicChartsData(geocodePayload)]),
      };

      setShowChart(true);

      realtyFunction?.[displayCharts]?.();
    }
  };

  const verifyGeneralMarketsChartData = (module: string) => {
    if (module === GENERAL_MARKETS.primary && primaryChartData) {
      dispatch([
        generatePrimaryMarketGeneralCharts(primaryChartData),
        setShowChart(true),
      ]);
    } else if (module === GENERAL_MARKETS.secondary && secondaryChartData) {
      dispatch([
        generateSecondaryMarketGeneralCharts(secondaryChartData),
        setShowChart(true),
      ]);
    } else if (module === GENERAL_MARKETS.transactions) {
      dispatch([
        // generateTransactionsGeneralCharts(transactionsChartData),
        setShowChart(true),
      ]);
    } else {
      dispatch([
        setShowChart(false),
        AddAlert(
          'warning',
          'Indicadores indisponíveis para a região pesquisada.'
        ),
      ]);
    }
  };

  const skipFormattingBigNumbers = (): boolean =>
    !!displayBigNumbersSocioeconomicDemographic;

  const displayDataSource = (): DataSource | undefined =>
    !!displayBigNumbersSocioeconomicDemographic
      ? dataSourceSocioeconomic
      : undefined;

  useEffect(() => {
    setShowBigNumbers(!!displayCharts);
    setShowChart(false);
  }, [displayCharts]);
  return (
    <>
      {displayCharts && (
        <>
          <div className="box-info-report">
            <div className="box-info-map">
              <BigNumbers
                bigNumbers={bigNumbers}
                indicatorsAction={generatingFunctionForEachRealty}
                skipFormatting={skipFormattingBigNumbers()}
                dataSource={displayDataSource()}
              />
            </div>
          </div>
        </>
      )}
      {showChart && (
        <>
          <ChartsPage />
        </>
      )}
    </>
  );
}

export default ReportResults;
